// eslint-disable-next-line no-restricted-imports
import { t, Trans } from '@lingui/macro'
import { Connector } from '@web3-react/types'
import {} from 'polished'
import { useMemo } from 'react'
import { Activity } from 'react-feather'
import styled from 'styled-components/macro'
import { AbstractConnector } from 'web3-react-abstract-connector'
import { UnsupportedChainIdError, useWeb3React } from 'web3-react-core'

import { NetworkContextName } from '../../constants/misc'
import useENSName from '../../hooks/useENSName'
import { useHasSocks } from '../../hooks/useSocksBalance'
import { useWalletModalToggle } from '../../state/application/hooks'
import { isTransactionRecent, useAllTransactions } from '../../state/transactions/hooks'
import { TransactionDetails } from '../../state/transactions/types'
import { shortenAddress } from '../../utils'
import { ButtonSecondary } from '../Button'
import StatusIcon from '../Identicon/StatusIcon'
// import Loader from '../Loader'
import WalletModal from '../WalletModal'

const IconWrapper = styled.div<{ size?: number }>``

const Web3StatusGeneric = styled(ButtonSecondary)``
const Web3StatusError = styled(Web3StatusGeneric)``

const Web3StatusConnect = styled(Web3StatusGeneric)<{ faded?: boolean }>``

const Web3StatusConnected = styled(Web3StatusGeneric)<{ pending?: boolean }>``

const Text = styled.p``

const NetworkIcon = styled(Activity)``

// we want the latest one to come first, so return negative if a is after b
function newTransactionsFirst(a: TransactionDetails, b: TransactionDetails) {
  return b.addedTime - a.addedTime
}

function Sock() {
  return (
    <span role="img" aria-label={t`has socks emoji`} style={{ marginTop: -4, marginBottom: -4 }}>
      🧦
    </span>
  )
}

function WrappedStatusIcon({ connector }: { connector: AbstractConnector | Connector }) {
  return (
    <IconWrapper size={16}>
      <StatusIcon connector={connector} />
    </IconWrapper>
  )
}

export function Web3StatusInner() {
  const { account, connector, error } = useWeb3React()

  const { ENSName } = useENSName(account ?? undefined)

  const allTransactions = useAllTransactions()

  const sortedRecentTransactions = useMemo(() => {
    const txs = Object.values(allTransactions)
    return txs.filter(isTransactionRecent).sort(newTransactionsFirst)
  }, [allTransactions])

  const pending = sortedRecentTransactions.filter((tx) => !tx.receipt).map((tx) => tx.hash)

  const hasPendingTransactions = !!pending.length
  const hasSocks = useHasSocks()
  const toggleWalletModal = useWalletModalToggle()

  if (account) {
    return (
      // <Web3StatusConnected id="" onClick={toggleWalletModal} pending={hasPendingTransactions}>
      //   {hasPendingTransactions ? (
      //     <>
      //       <Text>
      //         <Trans>{pending?.length} Pending</Trans>
      //       </Text>{' '}
      //       <Loader stroke="white" />
      //     </>
      //   ) : (
      //     <>
      //       {hasSocks ? <Sock /> : null}
      //       <Text>{ENSName || shortenAddress(account)}</Text>
      //     </>
      //   )}
      //   {!hasPendingTransactions && connector && <WrappedStatusIcon connector={connector} />}
      // </Web3StatusConnected>
      <li className="nav-item">
        <a className="d-none d-sm-inline btn-menu" onClick={toggleWalletModal}>
          {ENSName || shortenAddress(account)}
        </a>
        <a className="nav-link d-block d-sm-none " onClick={toggleWalletModal}>
          {ENSName || shortenAddress(account)}
        </a>
      </li>
    )
  } else if (error) {
    return (
      <Web3StatusError onClick={toggleWalletModal}>
        <NetworkIcon />
        <Text>{error instanceof UnsupportedChainIdError ? <Trans>Wrong Network</Trans> : <Trans>Error</Trans>}</Text>
      </Web3StatusError>
    )
  } else {
    return (
      <li className="nav-item">
        <a className="d-none d-sm-inline btn-menu" onClick={toggleWalletModal}>
          CONNECT
        </a>
        <a className="nav-link d-block d-sm-none" onClick={toggleWalletModal}>
          CONNECT
        </a>
      </li>
    )
  }
}

export function Web3statusText() {
  const { account, connector, error } = useWeb3React()

  const { ENSName } = useENSName(account ?? undefined)

  const allTransactions = useAllTransactions()

  const sortedRecentTransactions = useMemo(() => {
    const txs = Object.values(allTransactions)
    return txs.filter(isTransactionRecent).sort(newTransactionsFirst)
  }, [allTransactions])

  const pending = sortedRecentTransactions.filter((tx) => !tx.receipt).map((tx) => tx.hash)

  const hasPendingTransactions = !!pending.length
  const hasSocks = useHasSocks()
  const toggleWalletModal = useWalletModalToggle()

  if (account) {
    return (
      <>
        {hasSocks ? <Sock /> : null}
        <span>{ENSName || shortenAddress(account)}</span>
      </>
    )
  } else if (error) {
    return (
      <Web3StatusError onClick={toggleWalletModal}>
        <NetworkIcon />
        <Text>{error instanceof UnsupportedChainIdError ? <Trans>Wrong Network</Trans> : <Trans>Error</Trans>}</Text>
      </Web3StatusError>
    )
  } else {
    return (
      <Web3StatusConnect id="" onClick={toggleWalletModal} faded={!account}>
        <Text>
          <Trans>Connect Wallet</Trans>
        </Text>
      </Web3StatusConnect>
    )
  }
}

export default function Web3Status() {
  const { active, account } = useWeb3React()
  const contextNetwork = useWeb3React(NetworkContextName)

  const { ENSName } = useENSName(account ?? undefined)

  const allTransactions = useAllTransactions()

  const sortedRecentTransactions = useMemo(() => {
    const txs = Object.values(allTransactions)
    return txs.filter(isTransactionRecent).sort(newTransactionsFirst)
  }, [allTransactions])

  const pending = sortedRecentTransactions.filter((tx) => !tx.receipt).map((tx) => tx.hash)
  const confirmed = sortedRecentTransactions.filter((tx) => tx.receipt).map((tx) => tx.hash)

  return (
    <>
      <Web3StatusInner />
      {(contextNetwork.active || active) && (
        <WalletModal ENSName={ENSName ?? undefined} pendingTransactions={pending} confirmedTransactions={confirmed} />
      )}
    </>
  )
}
